import { c as _c } from "react/compiler-runtime";
import { Footer } from '../Footer';
import { Header } from './Header';
const BlogsLayout = t0 => {
  const $ = _c(7);
  const {
    children,
    tags,
    recentPost
  } = t0;
  let t1;
  if ($[0] !== recentPost || $[1] !== tags) {
    t1 = <Header tags={tags} recentPost={recentPost} />;
    $[0] = recentPost;
    $[1] = tags;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Footer />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== children || $[5] !== t1) {
    t3 = <>{t1}{children}{t2}</>;
    $[4] = children;
    $[5] = t1;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};
export default BlogsLayout;